import { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from '@/store/selectors/authSelectors';
import { selectAutoLoginFinished } from '@/store/selectors/autoLoginSelectors';
import { selectIsDRConsented } from '@/store/selectors/consentsSelectors';
import { envIsCanada } from '@/constants/constants';
import { useModal } from '@/features/modal/useModal';
import { MODALS } from '@/features/modal/types';

const useDetailsReverification = (): void => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const isLoginFinished = useSelector(selectAutoLoginFinished);
  const isDRConsented = useSelector(selectIsDRConsented);
  const { openModal } = useModal();

  useEffect(() => {
    // We want to show the modal only if:
    // 1. Build is Ontario
    // 2. User is logged in
    // 4. DETAILS_REVERIFICATION consent is not consented
    if (envIsCanada() && isAuthenticated && isLoginFinished && isDRConsented === false) {
      openModal(MODALS.DETAILS_REVERIFICATION, { noBackdropClick: true });
    }
  }, [isAuthenticated, isLoginFinished, isDRConsented]);
};

export default useDetailsReverification;
